const brandMapper = {
    expedia: "Exp",
    hotels: "Hcom",
    vrbo: "Vrbo"
}

export const sanityBrandMap = (brand?: string) => brandMapper[brand] || 'Exp';